export default class OrderDocument {
    id;
    invoiceNumber;
    fileName;
    orderId;
    constructor(id, invoiceNumber, revision, fileName, orderId) {
        this.id = id;
        this.invoiceNumber = invoiceNumber;
        this.fileName = fileName;
        this.orderId = orderId;
    }
}
